// I18n
import VueI18n from "vue-i18n";
import Vue from "vue";
import locale from "element-ui/lib/locale";
import { getLang } from "@/utils/lang";
 
// 引入 elementui 的多语言
import enLocale from "element-ui/lib/locale/lang/en.js";
import zhCnLocale from "element-ui/lib/locale/lang/zh-CN";
// 如果还有新的语言在下面继续添加
 
// 引入自己定义的 I18n 文件
import myI18nEn from "./lang/en.js";
import myI18nZh from "./lang/zh-cn.js";
// 如果还有新的语言在下面继续添加
// 注册 vue-i18n
Vue.use(VueI18n);
 
export const getLanguage = () => {
  // 本地缓存获取
  let language = getLang();
  if (language) {
    return language;
  }
  // 浏览器使用语言
  language = navigator.language.toLowerCase();
  if (language.indexOf('zh') > -1) {
    return "zh-CN";
  } else {
    return "en-US";
  }
}

// 默认中文
const i18n = new VueI18n({
  locale: getLanguage(),
  messages: {
    // 会把myI18nZh的所有内容拷贝到zhCnLocale文件中
    "zh-CN": Object.assign(zhCnLocale, myI18nZh),
    "en-US": Object.assign(enLocale, myI18nEn),
    // 如果还有新的语言在下面继续添加
  },
  silentTranslationWarn: true // 忽略翻译警告
});
locale.i18n((key, value) => i18n.t(key, value));
export default i18n;